import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { Tooltip, Typography } from '@lyearn/ui';
import { FilterItemProps } from '@/components/Filter/FilterItem/types';
import * as User from '@/components/User';
import { UserFragment } from '@/graphql/fragments/generated/User';
import { UserStatusEnum } from '@/types/schema';

import { UserFilterItemType } from '../hooks/useUsersFilter';

function UserFilterItem(props: FilterItemProps) {
  const { isSelected, option } = props;
  const user = option as unknown as UserFilterItemType;
  const { isMobile } = useScreen();

  const { t } = useTranslation();
  const isDeactivated = user.status === UserStatusEnum.Archived;

  return (
    <User.Provider
      alignItems="center"
      className="flex max-w-full flex-row items-center px-12 xs:px-0"
      user={option as unknown as UserFragment}>
      {option.Icon ? (
        <option.Icon
          // flex-shrink-0 is needed to prevent the icon from being squeezed
          className="h-22 w-22 flex-shrink-0"
          fillColorToken={isMobile ? 'icon-active' : 'icon-secondary'}
        />
      ) : (
        <User.ProfilePicture
          className="flex-shrink-0 rounded-full"
          disabled={isDeactivated}
          size={isMobile ? 24 : 22}
        />
      )}
      {isDeactivated ? (
        <Tooltip
          placement="right"
          title={`${option.label} ${t('Admin:DeactivatedIndicator')}`}
          variant="default">
          <Typography
            className="xs:body-short-01 truncate ms-12"
            color={isSelected ? 'text-text-primary' : 'text-text-placeholder'}
            title={option.label}
            variant="body-short-02">
            {option.label}
          </Typography>
        </Tooltip>
      ) : (
        <Typography
          className="xs:body-short-01 truncate ms-12"
          color={isSelected ? 'text-text-primary' : 'text-text-secondary'}
          title={option.label}
          variant="body-short-02">
          {option.label}
        </Typography>
      )}
    </User.Provider>
  );
}

export default React.memo(UserFilterItem);
